import { Buffer } from "buffer";

// Convert file to buffer
export const fileToBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onerror = () => {
      reader.abort();
      reject(new Error("Failed to parse file."));
    };
    reader.onload = () => {
      const arrayBuffer = reader.result;
      const buffer = Buffer.from(arrayBuffer, "utf8");
      resolve(buffer);
    };
  });
};
